import { getQueryVariable, sensorsMonitor, getWhiteTime } from '@/utils/utils';

export function checkIpesoInviteCode () {
  const iv = getQueryVariable('inviteCode');
  const hasCode = iv && iv.length;
  const { href } = window.location;

  return href.includes('ipeso') && !hasCode
}

export function registerMonitor() {
  const SaSdk = sensorsMonitor();
  SaSdk.registerPage({
    current_url: window.location.href,
    pagename: 'h5_register',
    appName: 'iPeso',
  })

  SaSdk.track('h5_register_pageview', {
    load_time: getWhiteTime()
  });
}